







import { defineComponent } from '@nuxtjs/composition-api';
import BaseFooterColumn from '@shared/components/@molecules/BaseFooterColumn/BaseFooterColumn.vue';
import responsiveMixin from '@shared/ui/utilities/mixins/responsiveMixin';
import Vue from 'vue';

Vue.component('BaseFooterColumn', BaseFooterColumn);
export default defineComponent({
  name: 'BaseFooter',
  mixins: [responsiveMixin],
  provide() {
    return {
      items: this.items,
    };
  },
  props: {
    column: {
      type: Number,
      default: 4,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    open: {
      type: [String, Array],
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: [],
      items: [],
    };
  },
  watch: {
    isMobile: {
      handler(mobile) {
        this.$nextTick(() => {
          // @ts-ignore migrated from ui-library
          this.isOpen = mobile ? [...this.open] : [...this.items];
        });
      },
      immediate: true,
    },
  },
  methods: {
    // @ts-ignore migrated from ui-library
    toggle(payload) {
      if (!this.isMobile) return;
      if (!this.multiple) {
        // @ts-ignore migrated from ui-library
        this.isOpen = [payload];
        // @ts-ignore migrated from ui-library
      } else if (this.isOpen.includes(payload)) {
        // @ts-ignore migrated from ui-library
        this.isOpen = this.isOpen.filter((item) => item !== payload);
      } else {
        // @ts-ignore migrated from ui-library
        this.isOpen.push(payload);
      }
      this.$emit('change', this.isOpen);
    },
  },
});
